import { render, staticRenderFns } from "./CarRecordingDrawer.vue?vue&type=template&id=8dfa1ba0&scoped=true"
import script from "./CarRecordingDrawer.vue?vue&type=script&lang=ts"
export * from "./CarRecordingDrawer.vue?vue&type=script&lang=ts"
import style0 from "./CarRecordingDrawer.vue?vue&type=style&index=0&id=8dfa1ba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfa1ba0",
  null
  
)

export default component.exports